import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Order } from '../Module/Order.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private get apiUrl(): string {
    return `${environment.apiUrl}/orders`;
  }

  constructor(private http: HttpClient) { }

  addOrder(order: Order): Observable<any> {
    return this.http.post<Order>(this.apiUrl, order, { observe: 'response' });
  }

  getOrderList(): Observable<Order[]> {
    return this.http.get<Order[]>(this.apiUrl);
  }

  getOrderById(id: number): Observable<Order> {
    return this.http.get<Order>(`${this.apiUrl}/${id}`);
  }

  deleteOrder(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  updateOrder(order: Order): Observable<any> {
    return this.http.put<Order>(`${this.apiUrl}/${order.id}`, order, { observe: 'response' });
  }

  makeVirtual(id: number): Observable<string> {
    return this.http.patch(`${this.apiUrl}/${id}/make-virtual`, {}, { responseType: 'text' });
  }

  // ✅ New method for paginated and filtered orders
  getPagedOrders(
    page: number,
    size: number,
    query?: string,
    status?: string,
    date?: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (query) params = params.set('query', query);
    if (status) params = params.set('status', status);
    if (date) params = params.set('date', date);

    return this.http.get<any>(`${this.apiUrl}/paged`, { params });
  }
  countOrders(): Observable<number> {
    return this.http.get<number>(`${this.apiUrl}/count`);
  }
  getPaymentSummary() {
    return this.http.get<{ paid: number, unpaid: number }>(`${this.apiUrl}/payment-summary`);
  }
  getPagedOrdersForClient(
    clientId: number,
    page: number,
    size: number,
    keyword?: string,
    status?: string,
    date?: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (keyword) params = params.set('keyword', keyword);
    if (status !== undefined && status !== null) params = params.set('status', status);
    if (date) params = params.set('date', date);

    return this.http.get<any>(`${this.apiUrl}/client/${clientId}/paged`, { params });
  }
  // order.service.ts
  bulkPayOrders(ids: number[]): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/pay`, ids);
  }

  getPagedOrdersByProduct(
    productIds: number[],
    clientId?: number,
    page: number = 0,
    size: number = 10,
    startDate?: string,
    endDate?: string
  ): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());

    productIds.forEach(id => {
      params = params.append('productIds', id.toString());
    });

    if (clientId) params = params.set('clientId', clientId.toString());
    if (startDate) params = params.set('startDate', startDate);
    if (endDate) params = params.set('endDate', endDate);

    return this.http.get<any>(`${this.apiUrl}/search-by-product`, { params });
  }

}
